import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { ActivityType } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/activityType/ActivityType'
import { BusinessUnit } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/businessUnit/BusinessUnit'
import { FocusArea } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/focusArea/FocusArea'
import { Incremental } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/incremental/Incremental'
import { InvestmentSource } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/investmentSource/InvestmentSource'
import { InvestmentSum } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/investmentSum/InvestmentSum'
import { KeyObjectives } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/keyObjectives/KeyObjectives'
import { KeyObjectiveTags } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/keyObkectiveTags/KeyObjectiveTags'
import { Name } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/name/Name'
import { Period } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/period/Period'
import { Status } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/status/Status'
import { GPKIValueTypeAndCurrency } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/gpKeyInitiatives/components/partnerView/components/gpKeyInitiativesEditor/components/gpKeyInitiativeEditorModal/components/gpKeyInitiativeEditorContent/components/GPKIValueTypeAndCurrency'
import { GP_KEY_INITIATIVE_FORM_KEY } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/gpKeyInitiatives/components/partnerView/components/gpKeyInitiativesEditor/components/gpKeyInitiativeEditorModal/components/gpKeyInitiativeEditorContent/configs'
import { IGPKeyInitiativeForm } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/gpKeyInitiatives/components/partnerView/components/gpKeyInitiativesEditor/models/gpKeyInitiativeForm'
import { isKeyObjectiveRelated } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/helpers/isKeyObjectiveRelated'
import { useBusinessUnits } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/hooks/useBusinessUnits'
import { useFocusAreaValues } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/hooks/useFocusAreaValues'
import { useIncremental } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/hooks/useIncremental'
import { KeyInitiativeInitTypes } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/models/keyInitiativeInitTypes'
import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/translations'
import { ApplyButton } from 'legacy/lut/components/widgets/public/partner360/editors/ApplyButton'
import { CancelButton } from 'legacy/lut/components/widgets/public/partner360/editors/CancelButton'
import { selectGPCountryCodes } from 'legacy/lut/features/globalPartner'
import { selectFinancialYear, selectRtm } from 'legacy/lut/features/partner360/configuration'
import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import {
  FormCheckBox,
  FormInput,
  FormTextarea,
  resetAllModifiedDataByKey,
  useGetFormData,
} from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { TFormValidationResult } from 'cng-common/features/form/models'
import { FormValidationBuilder } from 'cng-common/features/form/utils/validation'
import { Translation } from 'cng-common/features/translations/components/translation'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { Checkbox } from 'core-components/library/checkbox'
import { Grid, Item } from 'core-components/library/grid'
import { LoaderOverlay } from 'core-components/library/loader'
import { FormGeoSelector } from 'partner360/components/formComponents/formGeoSelector'
import { filterKeyInitiativeSettingsByYear } from 'partner360/features/keyInitiativeEditor/lib/filterKeyInitiativeSettingsByYear'

import styles from './GPKeyInitiativeEditorContent.module.scss'

interface IKeyInitiativeEditorContentProps {
  initialData?: IGPKeyInitiativeForm
  programType: ProgramTypes
  isCommercial: boolean
  isDataInsightPresent: boolean
  isDataInsightTab?: boolean
  keyObjectivesFilter?: string
  onApply: (
    form: IGPKeyInitiativeForm,
    isInvestmentNeeds: boolean,
    needCheckAffectedLp: boolean
  ) => Promise<void>
  onCancel: () => void
}

export const GPKeyInitiativeEditorContent = ({
  initialData,
  programType,
  onApply,
  onCancel,
  isCommercial,
  isDataInsightPresent,
  isDataInsightTab = false,
  keyObjectivesFilter,
}: IKeyInitiativeEditorContentProps) => {
  const dispatch = useAppDispatch()
  const t = useSafetyTranslation()
  const translationMode = useSelector(selectTranslationMode)
  const { jbpSettings } = useJbpSettings()
  const fYear = useSelector(selectFinancialYear)
  const gpCountryCodes = useSelector(selectGPCountryCodes)
  const rtm = useSelector(selectRtm)

  const [isLoading, setIsLoading] = useState(false)
  const [isInvestmentNeeds, setInvestmentNeeds] = useState(
    [initialData?.hpInvestmentSource, initialData?.hpInvestmentSum].some(Boolean)
  )
  const [{ formData, isValid, modifiedFields }] = useGetFormData(
    GP_KEY_INITIATIVE_FORM_KEY,
    initialData
  )

  const shouldShowAddToBridges = useMemo(() => {
    return fYear < 2024 ? isCommercial : true
  }, [fYear, isCommercial])

  const { incrementalInitialValue, isIncrementalRequired, incrementalFieldNameByValueType } =
    useIncremental<IGPKeyInitiativeForm>({
      initialData,
      formData,
    })

  const { keyObjectiveTagsSettingsList, keyObjectivesSettingsList } = useMemo(() => {
    return {
      keyObjectivesSettingsList: filterKeyInitiativeSettingsByYear(
        jbpSettings.keyObjectives,
        fYear
      ),
      keyObjectiveTagsSettingsList: filterKeyInitiativeSettingsByYear(
        jbpSettings.keyObjectiveTags,
        fYear
      ),
    }
  }, [fYear, jbpSettings.keyObjectives, jbpSettings.keyObjectiveTags])

  const isAutoCreatedKeyInitiative =
    formData?.initType === KeyInitiativeInitTypes.ImportedInitiative
  const isTranslationMode = translationMode === 'edit'
  const focusAreaValues = useFocusAreaValues({
    keyObjectives: keyObjectivesSettingsList,
    keyObjective: formData?.keyObjective,
  })
  const businessUnits = useBusinessUnits({
    programType,
    fYear,
  })

  const isLargeFormat = useMemo(() => {
    return programType === ProgramTypes.LargeFormat
  }, [programType])

  const goalFieldName = useMemo(() => {
    return `goal${formData?.valueType}`
  }, [formData?.valueType])

  const isGoalRequired = useMemo(() => {
    if (formData?.initType !== null) {
      return false
    }

    return shouldShowAddToBridges && formData?.shouldAddToBridges
  }, [shouldShowAddToBridges, formData])

  const handleValidate = useCallback(async () => {
    const formValidation = FormValidationBuilder.build(GP_KEY_INITIATIVE_FORM_KEY)
    const errors = await Promise.all(
      [
        formValidation.call('status', formData?.status),
        formValidation.call('name', formData?.name),
        keyObjectivesSettingsList.length &&
          formValidation.call('keyObjective', formData?.keyObjective),
        formValidation.call('activityType', formData?.period?.join(',')),
        formValidation.call('period', formData?.period?.join(',')),
        formValidation.call('description', formData?.description),
        isInvestmentNeeds && formValidation.call('hpInvestmentSum', formData?.hpInvestmentSum),
        isInvestmentNeeds &&
          formValidation.call('hpInvestmentSource', formData?.hpInvestmentSource),

        isGoalRequired && formValidation.call(goalFieldName, formData[goalFieldName]),
        isIncrementalRequired &&
          formValidation.call(
            incrementalFieldNameByValueType,
            formData[incrementalFieldNameByValueType]
          ),
      ].filter((it) => it)
    )

    return errors.filter((it): it is TFormValidationResult => it !== undefined)
  }, [
    formData,
    isInvestmentNeeds,
    keyObjectivesSettingsList,
    goalFieldName,
    isGoalRequired,
    isIncrementalRequired,
    incrementalFieldNameByValueType,
  ])

  const handleApply = useCallback(async () => {
    const errors = await handleValidate()
    if (errors.length > 0) {
      return
    }
    const needCheckAffectedLp =
      formData?.isCountriesAffected || modifiedFields.includes('IsCountriesAffected')
    setIsLoading(true)
    await onApply(formData, isInvestmentNeeds, needCheckAffectedLp)
    setIsLoading(false)
  }, [onApply, formData, isInvestmentNeeds, handleValidate, modifiedFields])

  useEffect(() => {
    return () => {
      dispatch(resetAllModifiedDataByKey(GP_KEY_INITIATIVE_FORM_KEY))
    }
  }, [dispatch])

  return (
    <div className={styles.root}>
      <LoaderOverlay show={isLoading} />
      <Grid noRootMargin direction="row">
        <Item xs={6}>
          <Name
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            initialValue={initialData?.name || ''}
            label={TRANSLATION_KEYS.keyInitiativeEditor.name}
          />
        </Item>
        <Item xs={6}>
          <Status
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            isDisabled={isAutoCreatedKeyInitiative}
            initialValue={initialData?.status}
          />
        </Item>
      </Grid>
      <Grid noRootMargin direction="row" alignItems={'center'}>
        <Item xs={6}>
          <FormGeoSelector
            allowedCountryCodes={gpCountryCodes}
            field={'countriesAffectedList'}
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            label={<Translation text={TRANSLATION_KEYS.gpKeyInitiativeEditor.geo} />}
            typeOfSelectedNodes={'onlyLeavesItems'}
            defaultValue={initialData?.countriesAffectedList || []}
          />
        </Item>
        <Item xs={6}>
          <FormCheckBox
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            field="isCountriesAffected"
            defaultValue={initialData?.isCountriesAffected || false}
            label={TRANSLATION_KEYS.gpKeyInitiativeEditor.affectToIncludingPartners}
          />
        </Item>
      </Grid>
      <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
        <Item xs={12}>
          <Translation
            text={TRANSLATION_KEYS.keyInitiativeEditor.keyInitiativeAndPeriodFieldGroup.groupHint}
          />
        </Item>
        <Item xs={6}>
          <KeyObjectives
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            isDisabled={isAutoCreatedKeyInitiative}
            className={styles.formField}
            initialValue={initialData?.keyObjective}
            keyObjectivesSettingsList={keyObjectivesSettingsList}
            programType={programType}
            keyObjectivesFilter={keyObjectivesFilter}
            label={
              TRANSLATION_KEYS.keyInitiativeEditor.keyInitiativeAndPeriodFieldGroup.development
            }
          />
        </Item>
        <Item xs={6}>
          <Period
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            isDisabled={isAutoCreatedKeyInitiative}
            className={styles.formField}
            initialValue={initialData?.period}
          />
        </Item>
        <Item xs={12}>
          <KeyObjectiveTags
            keyObjectiveTagsSettingsList={keyObjectiveTagsSettingsList}
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            initialValue={initialData?.keyObjectiveTags || []}
            programType={programType}
            rtm={rtm}
            label={
              TRANSLATION_KEYS.keyInitiativeEditor.keyInitiativeAndPeriodFieldGroup.keyObjectiveTags
            }
          />
        </Item>
        <Item xs={6}>
          <ActivityType
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            initialValue={initialData?.activityType}
          />
        </Item>
        <Item xs={6}>
          <FormInput
            isDisabled={isAutoCreatedKeyInitiative}
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            field="owner"
            defaultValue={initialData?.owner || ''}
            type="text"
            label={TRANSLATION_KEYS.keyInitiativeEditor.keyInitiativeAndPeriodFieldGroup.owner}
          />
        </Item>
      </Grid>

      {!isAutoCreatedKeyInitiative && (
        <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
          <Item xs={12}>
            <Translation
              text={TRANSLATION_KEYS.keyInitiativeEditor.checkboxesFieldGroup.groupHint}
            />
          </Item>
          {!isLargeFormat && isDataInsightPresent && (
            <Item xs={6}>
              <FormCheckBox
                isDisabled={
                  isKeyObjectiveRelated(keyObjectivesSettingsList, initialData) || isDataInsightTab
                }
                formKey={GP_KEY_INITIATIVE_FORM_KEY}
                field="isDataInsightRelated"
                defaultValue={initialData?.isDataInsightRelated || isDataInsightTab}
                label={TRANSLATION_KEYS.keyInitiativeEditor.checkboxesFieldGroup.dataInsightRelated}
              />
            </Item>
          )}

          {shouldShowAddToBridges && (
            <Item xs={6}>
              <FormCheckBox
                formKey={GP_KEY_INITIATIVE_FORM_KEY}
                field="shouldAddToBridges"
                defaultValue={initialData?.shouldAddToBridges || false}
                label={TRANSLATION_KEYS.keyInitiativeEditor.checkboxesFieldGroup.shouldAddToBridges}
              />
            </Item>
          )}
        </Grid>
      )}

      {!isAutoCreatedKeyInitiative && (
        <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
          <Item xs={12} className={styles.noMargin}>
            <Translation text={TRANSLATION_KEYS.keyInitiativeEditor.goalFieldGroup.groupHint} />
          </Item>
          <Item xs={3}>
            <Incremental
              formKey={GP_KEY_INITIATIVE_FORM_KEY}
              isRequired={isIncrementalRequired}
              initialValue={incrementalInitialValue}
              currency={formData?.currency}
              valueType={formData?.valueType}
              className={styles.formField}
              shouldAddToBridges={formData?.shouldAddToBridges}
              incrementalFieldName={incrementalFieldNameByValueType}
              isFromGlobalPartner
              goalFieldName={goalFieldName}
            />
          </Item>
          <Item xs={6}>
            <GPKIValueTypeAndCurrency initialValueType={initialData?.valueType} />
          </Item>
        </Grid>
      )}

      <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
        <Item xs={12}>
          <Translation
            text={TRANSLATION_KEYS.keyInitiativeEditor.businessUnitAndFocusFieldGroup.groupHint}
          />
        </Item>
        <Item xs={6}>
          <BusinessUnit
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            initialValue={initialData?.businessUnit}
            businessUnits={businessUnits}
            className={styles.formField}
            label={TRANSLATION_KEYS.keyInitiativeEditor.businessUnitAndFocusFieldGroup.businessUnit}
          />
        </Item>
        <Item xs={6}>
          <FocusArea
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            isDisabled={isAutoCreatedKeyInitiative}
            initialValue={initialData?.focusArea}
            focusAreaValues={focusAreaValues}
            className={styles.formField}
            businessUnit={formData?.businessUnit}
            fYear={fYear}
            programType={programType}
          />
        </Item>
        <Item xs={12}>
          <FormTextarea
            isDisabled={isAutoCreatedKeyInitiative}
            isRequired={!isAutoCreatedKeyInitiative}
            formKey={GP_KEY_INITIATIVE_FORM_KEY}
            field="description"
            defaultValue={initialData?.description || ''}
            onValidate={ValidationHelper.checkString}
            validationType={ValidationType.ONCHANGE}
            label={TRANSLATION_KEYS.keyInitiativeEditor.businessUnitAndFocusFieldGroup.description}
          />
        </Item>
      </Grid>

      {isAutoCreatedKeyInitiative && (
        <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
          <Item xs={12}>
            <Translation
              text={
                TRANSLATION_KEYS.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup
                  .groupHint
              }
            />
          </Item>
          <Item xs={12}>
            {isTranslationMode && (
              <Translation
                text={
                  TRANSLATION_KEYS.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup
                    .goalDescription
                }
              />
            )}
            {!isTranslationMode && (
              <FormTextarea
                isDisabled={isAutoCreatedKeyInitiative}
                formKey={GP_KEY_INITIATIVE_FORM_KEY}
                field="goalDescription"
                defaultValue={initialData?.goalDescription || ''}
                label={
                  TRANSLATION_KEYS.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup
                    .goalDescription
                }
              />
            )}
          </Item>
          <Item xs={12}>
            <FormCheckBox
              isDisabled={isAutoCreatedKeyInitiative}
              formKey={GP_KEY_INITIATIVE_FORM_KEY}
              field="isAchieved"
              defaultValue={initialData?.isAchieved || false}
              label={
                TRANSLATION_KEYS.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup
                  .isAchieved
              }
            />
          </Item>
          <Item xs={12}>
            {isTranslationMode && (
              <Translation
                text={
                  TRANSLATION_KEYS.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup
                    .proofOfExecution
                }
              />
            )}
            {!isTranslationMode && (
              <FormTextarea
                isDisabled={isAutoCreatedKeyInitiative}
                formKey={GP_KEY_INITIATIVE_FORM_KEY}
                field="proofOfExecution"
                defaultValue={initialData?.proofOfExecution || ''}
                label={
                  TRANSLATION_KEYS.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup
                    .proofOfExecution
                }
                className={styles.formField}
              />
            )}
          </Item>
        </Grid>
      )}

      <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
        <Item xs={12} className={styles.investmentNeedsWrapper}>
          <Checkbox
            checked={isInvestmentNeeds}
            label={t(TRANSLATION_KEYS.keyInitiativeEditor.investmentFieldGroup.groupHint)}
            onChange={setInvestmentNeeds}
          />
        </Item>
      </Grid>

      {isInvestmentNeeds && (
        <Grid noRootMargin direction="row">
          <Item xs={6}>
            <InvestmentSum
              formKey={GP_KEY_INITIATIVE_FORM_KEY}
              initialValue={initialData?.hpInvestmentSum}
              className={styles.formField}
              label={TRANSLATION_KEYS.keyInitiativeEditor.investmentFieldGroup.investmentSum}
            />
          </Item>
          <Item xs={6}>
            <InvestmentSource
              formKey={GP_KEY_INITIATIVE_FORM_KEY}
              initialValue={initialData?.hpInvestmentSource}
              className={styles.formField}
              label={TRANSLATION_KEYS.keyInitiativeEditor.investmentFieldGroup.investmentSource}
            />
          </Item>
        </Grid>
      )}

      <Grid noRootMargin direction="row">
        <Item xs={12} className={styles.buttonsContainer}>
          <ApplyButton
            className={styles.applyButton}
            disabled={!isValid || isLoading}
            onClick={handleApply}
          />
          <CancelButton onClick={onCancel} className={styles.cancelButton} color="grey" />
        </Item>
      </Grid>
    </div>
  )
}
